module.exports = __webpack_public_path__ + "img/correct.43149f74.png";